











import Vue from 'vue';
import CustomType from '../../types/vue';

export interface ComponentApp extends Vue {
    newValue: string
    value: string
    isRequired: Boolean
    action: (result: string|Number, Sucess: Boolean) => any
    success: Boolean  
    placeholder: string 
    isDisabled: Boolean
    capitalize: (str: string) => string
    translateMessage: (str: string) => string
    isEmail: Boolean
    isNumber: Boolean
}

var component: Vue.ComponentOptions<ComponentApp> = {
    name: 'Input',
    data () {
        return {
            newValue: this.value
        }
    },
    props: {
        placeholder: { type: String, required: false },
        value: { required: false },
        action: { type: Function, required: true },
        isRequired: { type: Boolean, required: false, default: false },
        isDisabled: { type: Boolean, required: false, default: false },
        isEmail: { type: Boolean, required: false, default: false},
        isNumber: { type: Boolean, required: false, default: false},
    },
    computed: {
        success: function () {
            if (this.isRequired){
                if(this.isEmail){
                    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if(regex.test(this.newValue))
                        return true;
                    else
                        return false
                }
                return this.newValue.trim() != ""
            }else
                return true;
        },
    },
    watch: {
        newValue: function (val) {
            if (Number.isInteger(parseInt(val.trim())) && this.isNumber){
                this.action(Number(val.trim()), this.success);
            }else{
                this.action(val.trim(), this.success);
            }
        },
        value: function (val) {
            this.newValue = val
        }
    },
    filters: {
        capitalize (str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        }
    },
    methods: {
        translateMessage: function (cle) {
            if (Number.isInteger(parseInt(cle)))
                return cle

            if (cle === "" || cle === undefined || cle === null)
                return "";

            return this.translate(this.$language, cle);
        },
    }
}

export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/Input.vue